import React, { Component } from 'react'
// import data from "../../assets/data.json";
import ProjectBriefCard from './ProjectBriefCard';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { connect } from 'react-redux';
import Loader from 'react-loader-spinner';
import * as MDICONS from '@material-ui/icons';
import { actionTypes } from 'redux-firestore';

import { setCurrentProjectId } from '../../store/actions/projectActions';

class AllProjects extends Component {

    /// WARNING: DO NOT REMOVE OR CHANGE WITHOUT DISCUSSIONS AND PERMIT
    handleClear = () => {
        // set project id to -1 to deliberately fail fetching any false document (this is done to overwrite the cache)
        this.props.setCurrentProjectId("-1");

        // then clear the entire store but preserve some (see down)
        this.props.clearData();
    }

    componentDidMount() {
        // clear everything except Projects store
        this.handleClear();
    }

    render() {
        const data = this.props.allProjects;
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }

        if (data) {
            if (data.length !== 0) {
                return (
                    <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4">
                        {data.map((projectCard, index) => <ProjectBriefCard key={index} projectCard={projectCard} />)}
                    </div>
                )
            } else {
                return (
                    <div>
                        <h5 style={textStyle}>You've no projects <MDICONS.CheckCircleSharp /></h5>
                        <br></br>
                    </div>
                );
            }
        } else {
            return (
                <React.Fragment>
                    <Loader
                        type="Grid"
                        color={this.props.themeColors.themeColor}
                        height={50}
                        width={50}
                    />
                    <br></br>
                    <p style={textStyle}>Getting all your projects</p>
                    <br></br>
                </React.Fragment>
            )
        }
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        themeColors: state.theme,
        allProjects: state.firestore.ordered.Projects,
        userData: state.firebase.profile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentProjectId: (proid) => dispatch(setCurrentProjectId(proid)),
        // DOCS: https://github.com/prescottprue/redux-firestore/issues/114
        clearData: () => dispatch({ type: actionTypes.CLEAR_DATA, preserve: { data: ['Projects', 'Company', 'CompanyBriefings', 'Notifications', 'ProductOrder','CommonQuestions'], ordered: ['Projects', 'Company', 'CompanyBriefings', 'Notifications', 'ProductOrder','CommonQuestions'] } }),
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect((props) => {
        var ueid = props.auth.uid + props.userData.employeeid;
        var coid = props.userData.coid;
        if (coid === "-1") {
            return [
                {
                    collection: 'Projects',
                    where: [['accessList', 'array-contains', `${ueid}`]],
                    orderBy: [['dateCreated', 'desc']],
                }
            ]
        } else {
            return [
                {
                    collection: 'Projects',
                    where: [['accessList', 'array-contains', `${ueid}`], ['coid', '==', `${coid}`]],
                    orderBy: [['dateCreated', 'desc']],
                }
            ]
        }
    })
)(AllProjects);